import React from "react";
import { motion } from "framer-motion";
import ParticleEffect from "./ParticleEffect";
import FooterSection from "./FooterSection";
import { useNavigate } from "react-router-dom";

const ReadySection = () => {
  const navigate = useNavigate();

  return (
    <>
      <section
        id="ready"
  className="py-16 md:py-32 px-4 sm:px-8 bg-transparent scale-100 md:scale-[0.9] pt-[60px] md:pt-[50px] pb-[30px] md:pb-[100px]"
      >
        <div className="max-w-[1600px] mx-auto">

          {/* SAME SIZE CARD — DO NOT CHANGE */}
          <motion.div
            className="relative rounded-[20px] md:rounded-[20px] px-6 py-8 md:px-10 md:py-10 lg:px-20 
                       h-auto min-h-[320px] md:h-[375px]
                       text-center mb-12 md:mb-20 overflow-hidden w-full max-w-full md:w-[1000px] mx-auto"
            style={{
              background: "linear-gradient(180deg, #161616, #0d0d0d)",
              color: "white",
            }}
            initial={{ opacity: 0, scale: 0.94 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            {/* ✨ Particles */}
            <ParticleEffect speed={0.15} density={40} color="#ffffff30" />

            {/* ========================================================= */}
            {/*          SHRUNK TEXT SO IT FITS THE FIXED CARD HEIGHT      */}
            {/* ========================================================= */}

            <div className="relative z-10 flex flex-col items-center justify-center mt-[20px]">
              <h2 className="text-[32px] sm:text-[36px] md:text-[42px] font-bold leading-[1.1] mb-3 px-2">
                Ready to Level Up?
              </h2>

              <p className="max-w-full md:max-w-[700px] mx-auto text-[15px] md:text-[16px] lg:text-[20px] 
                            text-white/90 mb-6 md:mb-8 leading-snug px-4">
                Whether it’s a one-off edit or a full channel transformation, 
                we’re ready when you are. Let’s talk ideas.
              </p>

              <motion.button
                className="bg-white text-black rounded-full 
                        px-8 py-3 md:px-10 md:py-4 text-[16px] md:text-[18px] font-semibold 
                        inline-flex items-center gap-3 shadow-md"
                whileHover={{ scale: 1.07 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => navigate("/contact")}
              >
                Book a Call
                <span className="h-8 w-8 md:h-9 md:w-9 rounded-full bg-[rgb(255,81,0)] 
                                text-white flex items-center justify-center text-[18px] md:text-[20px]">
                  →
                </span>
              </motion.button>
            </div>
          </motion.div>
        </div>
      </section>

      <FooterSection />
    </>
  );
};

export default ReadySection;
